<template>
  <transition name="fade">
    <div v-if="value" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-logo">
          <img :src="shizenLogo" alt="">
        </div>
        <div class="loading-text">
          {{ dispText }}
        </div>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>

// Utils
import { shizenLogo } from '@/utils/main';

export default {
  name: 'LoadingOverlay',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      shizenLogo,
    };
  },

  computed: {
    /** String text displayed below logo */
    dispText() {
      return this.text !== null ? this.text : this.$t('message.LOADING_DOTS');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.loading-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  background: rgba(255, 255, 255, 0.6);

  .loading-content {
    text-align: center;
  }
  .loading-logo {
    width: 5em;
    height: 5em;
    margin: auto;

    img {
      animation: rotation 2s infinite linear;
      width: 100%;
      display: block;
    }
  }
  .loading-text {
    margin-top: 1em;
  }
}

</style>
